import React from "react";
import { Pressable, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import tw from "twrnc";
import Text from "@/components/shared/AppText";
import { FUNERAL_TRIAL_CREDITS } from "./funeralHomeIntent";
import { t, tn } from "@/localization";

const GiftBadge = () => (
  <View style={tw`mr-4`}>
    <View
      style={tw`w-16 h-16 rounded-full bg-green-600 border-4 border-green-200 items-center justify-center`}
    >
      <Ionicons name="gift" size={30} color="#ffffff" />
    </View>
    <Ionicons
      name="sparkles"
      size={18}
      color="#f59e0b"
      style={{ position: "absolute", top: -4, right: -6 }}
    />
  </View>
);

// Shown on the event list to a funeral home from eventlive.pro/funeral-streaming
// until it schedules its first service or dismisses it. No buttons of its own:
// the event list already offers scheduling and test streams.
const FuneralWelcomeBanner = ({ intent, credits, onDismiss, style }) => {
  if (!intent) return null;
  const freeCredits = Number(credits) || 0;
  const name = intent.companyName || "";

  const title =
    freeCredits > 0
      ? tn(
          "Your {count} free service is ready",
          "Your {count} free services are ready",
          freeCredits
        )
      : name
      ? t("Welcome to EventLive, {name}", { name })
      : t("Welcome to EventLive");
  const text =
    freeCredits > 0
      ? t(
          "Schedule a service to get a private link for the family — each service uses one credit. Want to practise first? Test streams are always free."
        )
      : intent.trial
      ? t(
          "Your {count} free services appear here as credits within a minute of signing up. Not there? Message us and we'll add them.",
          { count: FUNERAL_TRIAL_CREDITS }
        )
      : t(
          "Schedule a service to get a private link for the family. Want to practise first? Test streams are always free."
        );

  return (
    <View
      style={[tw`p-4 rounded-xl border border-green-200 bg-green-50`, style]}
    >
      <View style={tw`flex-row items-center`}>
        <GiftBadge />
        <View style={tw`flex-1`}>
          <Text style={tw`font-bold text-base`}>{title}</Text>
          <Text style={tw`text-gray-700 mt-1 leading-5`}>{text}</Text>
        </View>
        <Pressable
          accessibilityRole="button"
          accessibilityLabel={t("Dismiss welcome")}
          onPress={onDismiss}
          hitSlop={10}
          style={tw`ml-2 self-start`}
        >
          <Ionicons name="close" size={20} color="#8E8E93" />
        </Pressable>
      </View>
    </View>
  );
};

export default FuneralWelcomeBanner;
